import { useTranslation } from 'react-i18next';
import type { Appointment } from '@/api/mcp-appointments';
import { useClientCustomerDisplayMap } from '@/hooks/useClientCustomerDisplayMap';
import { getAppointmentClientDisplayLabel } from '../appointmentClientDisplay';

/** Display name and contact details of the person an appointment is booked for. */
export interface AppointmentClientContact {
  name: string;
  phone: string | null;
  email: string | null;
}

/**
 * Resolves who an appointment is for: the anonymous guest fields first, then the registered customer.
 */
export function useAppointmentClientContact(appointment: Appointment): AppointmentClientContact {
  const { t } = useTranslation('manage');
  const { userDisplayById } = useClientCustomerDisplayMap();
  const registeredCustomer = appointment.userId ? userDisplayById.get(appointment.userId) : undefined;

  const name =
    appointment.anonymousName?.trim() ||
    registeredCustomer?.name?.trim() ||
    getAppointmentClientDisplayLabel(appointment, t('appointmentComponents.details.anonymous'), userDisplayById);

  return {
    name,
    phone: appointment.anonymousPhone || registeredCustomer?.phone || null,
    email: appointment.anonymousEmail || registeredCustomer?.email || null
  };
}
